import React from 'react';
import classNames from 'classnames';

class TabSectionTab extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    this.props.onClick(this.props.tabIndex);
  }

  render() {
    const className = classNames('TabSection-tab', {
      'TabSection-tab--active': this.props.isActive,
    });

    return (
      <li>
        <button
          type="button"
          className={className}
          onClick={this.handleClick}
          onKeyDown={e => e.key === 'Enter' && this.handleClick()}
        >
          {this.props.title}
        </button>
      </li>
    );
  }
}

export default TabSectionTab;
